import { render, staticRenderFns } from "./PerformanceRating.vue?vue&type=template&id=4f4005b1&scoped=true"
import script from "./PerformanceRating.vue?vue&type=script&lang=js"
export * from "./PerformanceRating.vue?vue&type=script&lang=js"
import style0 from "./PerformanceRating.vue?vue&type=style&index=0&id=4f4005b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4005b1",
  null
  
)

export default component.exports